// src/components/Common/Spinner.jsx

import { useTranslation } from 'react-i18next';

/**
 * Spinner
 * Componente reutilizable que muestra un overlay de carga centrado.
 * Se puede usar en cualquier parte del proyecto para indicar procesos en curso.
 */
const Spinner = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(3, 3, 3, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <div
        className="spinner-border text-primary"
        style={{ width: '5rem', height: '5rem', borderRadius: "50%"  }}
        role="status"
      >
        {/* Texto accesible para lectores de pantalla */}
        <span className="visually-hidden">{t('Cargando...')}</span>
      </div>
    </div>
  );
};

export default Spinner;
